import { __ } from "@wordpress/i18n";
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import PageHeading from '../components/PageHeading/PageHeading';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
PageHeading
const MoreStatus = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [log, setLog] = useState('');

    useEffect(() => {
        const fetchLog = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-log-status",
                    method: 'GET'
                });
        
                setLog(results);
        
            } catch (error) {
                console.error("Error fetching log:", error);
            }
        };
        fetchLog();
    }, []);
    const handleCopyById = (elementId) => {
        try {
            const element = document.getElementById(elementId);
            if (!element) {
                alert(__("Element not found", 'ultimate-security' ));
                return;
            }
    
            const text = element.innerText || element.textContent; // Get text content
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy"); // Fallback API
            document.body.removeChild(textArea);
    
            alert(__("Text Copied Successfully", 'ultimate-security' ));
        } catch (error) {
            console.error(__( "Failed to copy text: ", 'ultimate-security' ), error);
        }
    };
    const handlePrintById = (elementId) => {
        const element = document.getElementById(elementId);
        if (!element) {
          alert(__("Element not found!", 'ultimate-security' ));
          return;
        }
    
        const printContents = element.innerHTML;
        const printWindow = window.open("", "_blank");
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Print</title>
              <style>
                /* Add custom print styles here */
                body {
                  font-family: Arial, sans-serif;
                  padding: 20px;
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };
    return (
        <>
            <div className="setting-unit px-lg" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                <PageHeading 
                    title={__("Status", "ultimate-security")}
                    subtitle={__("Review the current settings and configuration of the plugin. Stay informed with detailed information about the plugin version, name, and active settings to ensure everything is up-to-date.", "ultimate-security")}
                />
            </div>
            <div className="setting-unit pb-lg mb-lg pt-lg mt-lg border-top">
                <div className="panel-wrapper">
                    <div className="panel">
                        <div className="panel-header">Status</div>
                        <div className="panel-body">
                            <div id="copy-content" dangerouslySetInnerHTML={{ __html: log }}></div>
                        </div>
                        <div className="panel-footer">Scroll down to see more.</div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mt-lg">
                        <div className="info">ℹ️If you need help, copy and paste the above information for faster support.</div>
                        <div className="d-flex align-items-center action-buttons">
                            <button className="copy-content" onClick={()=> handleCopyById('copy-content')}>{__( 'Copy', 'ultimate-security' )}</button>
                            <button className="print-content" onClick={() => handlePrintById("copy-content")}>{__( 'Print', 'ultimate-security' )}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(MoreStatus);